import React from 'react';
import { Radio as AntRadio } from 'antd';
import type { RadioProps } from 'antd';
import clsx from 'clsx';

export const Radio = ({ className, ...props }: RadioProps) => (
  <AntRadio {...props} className={clsx('wk-radio', className)} />
);

Radio.Group = AntRadio.Group;
Radio.Button = AntRadio.Button;
